<template>
    <df-app>
        <div class="row">
            <div class="col-lg-8 offset-lg-2">
                <be-loading :active="submitting">
                    <form @submit.prevent="submit">
                        <be-card border-color="primary" divider featured footer-contrast title="Passwort ändern" subtitle="Geben Sie Ihr bestehendes und ein neues Passwort ein.">
                            <text-field ref="currentPassword" label="Aktuelles Passwort" autofocus v-model="currentPassword" :validation="$v.currentPassword"/>

                            <text-field label="Neues Passwort" v-model="newPassword" :validation="$v.newPassword"/>
                            <text-field label="Passwort bestätigen" v-model="passwordConfirm" :validation="$v.passwordConfirm"/>

                            <template #footer>
                                <div class="text-right">
                                    <submit-button>Passwort ändern</submit-button>
                                </div>
                            </template>
                        </be-card>
                    </form>
                </be-loading>
            </div>
        </div>
    </df-app>
</template>

<script>
    import { mapGetters } from 'vuex';
    import { withParams } from 'vuelidate';
    import { required, sameAs } from 'vuelidate/lib/validators';
    import { password } from '../../../validators';

    export default {
        data: () => ({
            currentPassword: '',
            newPassword: '',
            passwordConfirm: '',
            submitting: false,
        }),

        computed: {
            ...mapGetters('user', ['user']),
        },

        validations: {
            currentPassword: { required, password },
            newPassword: { required, password },
            passwordConfirm: {
                required,
                password,
                sameAsPassword: withParams({ message: 'Das Passwort stimmt nicht überein.' }, sameAs('newPassword')),
            },
        },

        methods: {
            async submit() {
                this.$v.$touch();

                if (this.$v.$pending || this.$v.$error) {
                    return;
                }

                this.submitting = true;

                try {
                    await this.$store.dispatch('user/changePassword', {
                        currentPassword: this.currentPassword,
                        newPassword: this.newPassword,
                    });

                    this.$store.dispatch('notifications/add', {
                        color: 'success',
                        title: 'Passwort geändert!',
                        description: 'Das neue Passwort ist ab sofort gültig.',
                    });
                    this.$router.push({ name: 'home' });
                } catch (err) {
                    this.$store.dispatch('notifications/add', {
                        color: 'danger',
                        title: 'Passwort nicht geändert',
                        description: 'Das bestehende Password wurde nicht korrekt eingegeben!',
                    });

                    this.currentPassword = '';
                    this.$refs.currentPassword.focus();
                } finally {
                    this.submitting = false;
                }
            },
        },
    };
</script>
